import { VueRouter, Route, NavigationGuardNext } from 'vue-router/types/router.d';
import { hasAuthority } from '@/utils';

import { clientsModule, authModule } from '@/store';

async function goAuthenticated(route: Route, next: NavigationGuardNext) {
  if (route.name === 'home') {
    if (hasAuthority(authModule.permissions, ['client:read'])) {
      return next({ name: 'clients' });
    }
    if (hasAuthority(authModule.permissions, ['user:read', 'user:write', 'sm_user:read', 'sm_user:write'])) {
      return next({ name: 'users' });
    }
    if (hasAuthority(authModule.permissions, ['supplier:operate'])) {
      return next({ name: 'supplier-things' });
    }
    if (hasAuthority(authModule.permissions, ['marketing:read'])) {
      return next({ name: 'promo-cards' });
    }
    return next({ name: 'catalog' });
  }
  const authorized = hasAuthority(authModule.permissions, route.meta.authorities);
  if (authorized) {
    // маршрут разрешен
    const clientId = clientsModule.model && clientsModule.model.id;
    if (!!route.meta.clients && Number(route.params.clientId)
      && (Number(route.params.clientId) !== clientId)) {
      await clientsModule.fetchClient(Number(route.params.clientId));
    }
    return next();
  }
  // маршрут запрещен
  // eslint-disable-next-line no-console
  console.log('Deny for user route:', route.fullPath, 'go:', '/access-denied');
  return next('/access-denied');
}

// переход для неаутентифицированного пользователя
function goNotAuthenticated(route: Route, next: NavigationGuardNext) {
  // eslint-disable-next-line no-console
  console.log('Not authenticated user, route:', route.fullPath, 'go:', '/login');
  // пользователь не аутентифицирован
  if (route.query.redirect || route.name === 'home') {
    // без редиректа
    next({ name: 'login' });
  } else {
    next({ name: 'login', query: { redirect: route.fullPath } });
  }
}

const registerRouteGuard = (router: VueRouter) => {
  router.beforeEach(async (to, from, next) => {
    if (to.meta.notAuthenticated) {
      // разрешен переход неаутентифицированным пользователям
      next();
    } else if (authModule.hasAuthentication) {
      await goAuthenticated(to, next);
    } else if (authModule.hasAuthIdentification) {
      try {
        const sessionUser = await authModule.syncMe();
        if (sessionUser) {
          await goAuthenticated(to, next);
        }
      } catch (e) {
        localStorage.removeItem('jwtToken');
        next({ name: 'login' });
      }
    } else {
      goNotAuthenticated(to, next);
    }

    return next();
  });
};

export default registerRouteGuard;
